import { render } from "./raised2Page.vue?vue&type=template&id=68ba868f"
import script from "./raised2Page.vue?vue&type=script&lang=js"
export * from "./raised2Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__